export default function allowed() {
	return Tools.FeatureHelper.hasSoftDeployAccess('TODO_LIST');
}
